import React from 'react';
import classes from './loader.module.scss';

function Loader(props) {
  return (<div className={classes.loader}>{' '}</div>);
}

export default Loader;
